<template>
<div class="container-menu">
    <div id="settings" class="animated-topbutton tamanhoicon" @click="$emit('settings', somTeclas); somclick()">
        <img :src="require('@/assets/buttons/newbuttons/' + num_game(current_game) + '/settings.svg')"/>
    </div>
    <div v-if="!guest" id="profile" class="animated-topbutton tamanhoicon" @click="$emit('Profile', character); somclick()">
        <img :src="require('@/assets/menu/menu_characters/' + character + '.png')" />
    </div>
    <div v-if="!guest" id="gallery" class="animated-topbutton tamanhoicon" @click="$emit('Gallery'); somclick()">
        <img :src="require('@/assets/buttons/newbuttons/' + num_game(current_game) + '/gallery.svg')" />
    </div>
    <div class="carousel" id="class" aria-label="Gallery">
        <ol id="menu_carousel__viewport" class="carousel__viewport">
            <li id="melody" tabindex="1" class="carousel__slide">
                <div class="carousel__snapper">
                    <span class="title-menu title tamanhotitle">{{$t('games.melody.title')}}</span>

                    <div class="window">
                        <img @click="$emit('melody'); somclick()" class="tamanhojanelamelodia" :src="require('@/assets/janelas/melody.png')" />
                    </div>
                    <img class="backgroundTop backgroundColor" :src="require('@/assets/backgrounds/menu/solidcolorMelody.svg')" />
                    <img class="fundo backgroundBottom" :src="require('@/assets/backgrounds/menu/melodyvetor-min.png')" />
                </div>
            </li>
            <li id="dance" tabindex="2" class="carousel__slide">
                <div class="carousel__snapper">
                    <span class="title-menu title tamanhotitle">{{$t('games.dance.title')}}</span>
                    <div class="window">
                        <img @click="$emit('dance'); somclick()" class="tamanhojaneladanca" :src="require('@/assets/janelas/dance.png')" />
                    </div>
                    <img class="backgroundTop backgroundColor" :src="require('@/assets/backgrounds/menu/solidcolorDance.svg')" />
                    <img class="fundo backgroundBottom" :src="require('@/assets/backgrounds/menu/dancevetor-min.png')" />
                </div>
            </li>
            <li id="rhythm" tabindex="3" class="carousel__slide">
                <div class="carousel__snapper">
                    <span class="title-menu title tamanhotitle">{{$t('games.rhythm.title')}}</span>
                    <div class="window">
                        <img @click="$emit('rhythm'); somclick()" class="tamanhojanelaritmo" :src="require('@/assets/janelas/rhythm.png')" />
                    </div>
                    <img class="backgroundTop backgroundColor" :src="require('@/assets/backgrounds/menu/solidcolorRhythm.svg')" />
                    <img class="fundo backgroundBottom" :src="require('@/assets/backgrounds/menu/rhythmvetor-min.png')" />
                </div>
            </li>
            <li id="sing" tabindex="4" class="carousel__slide">
                <div class="carousel__snapper">
                    <span class="title-menu title tamanhotitle">{{$t('games.sing.title')}}</span>
                    <div class="window">
                        <img @click="$emit('sing'); somclick()" class="tamanhojanelasing" :src="require('@/assets/janelas/sing.png')" />
                    </div>
                    <img class="backgroundTop backgroundColor" :src="require('@/assets/backgrounds/menu/solidcolorSing.svg')" />
                    <img class="fundo backgroundBottom" :src="require('@/assets/backgrounds/menu/singvetor-min.png')" />
                </div>
            </li>
        </ol>
    </div>
    <div class="carousel__navigation">
        <div class="carousel__navigation-list">
            <a @click="scroll_to_game(1)" :class="{'selected-game' : current_game == 1}" class="carousel__navigation-button"></a>
            <a @click="scroll_to_game(2)" :class="{'selected-game' : current_game == 2}" class="carousel__navigation-button"></a>
            <a @click="scroll_to_game(3)" :class="{'selected-game' : current_game == 3}" class="carousel__navigation-button"></a>
            <a @click="scroll_to_game(4)" :class="{'selected-game' : current_game == 4}" class="carousel__navigation-button"></a>
        </div>
    </div>
    <div>
        <a id="menu_play" class="animated-bottombutton tamanhoicon">
            <img @click="$emit(num_game(current_game)); somclick()" :src="require('@/assets/buttons/newbuttons/' + num_game(current_game) + '/play.svg')" />
        </a>
        <a id="back" class="animated-bottombutton tamanhoicon" @click="previous_game">
            <img :src="require('@/assets/buttons/newbuttons/' + num_game(current_game) + '/seta_esq.svg')" />
        </a>
        <a id="forward" class="animated-bottombutton tamanhoicon" @click="next_game">
            <img :src="require('@/assets/buttons/newbuttons/' + num_game(current_game) + '/seta_drt.svg')" />
        </a>
    </div>
</div>
</template>

<script>
export default {
    name: "Menu",
    emits: ['settings', 'profile', 'melody', 'dance', 'rhythm', 'sing', 'gallery'],
    components: {},
    props: {
        character: Number,
        somTeclas: Boolean,
        guest: Boolean
    },
    data() {
        return {
            current_game: 1,
            n_games: 4,
            posInicial: 0,
            posFinal: 0,
            last_scroll: 0,
            click:'',

        };
    },
    methods: {
        previous_game() {
            if(this.somTeclas){
            this.click.play();
            }
            if (this.current_game > 1) {
                this.current_game -= 1;
            } else if (this.current_game === 1) {
                this.current_game = this.n_games;
            }
            this.scroll_to_game(this.current_game);
            console.log(this.current_game);
        },
        next_game() {
            if(this.somTeclas){
            this.click.play();
            }
            if (this.current_game < this.n_games) {
                this.current_game += 1;
            } else if (this.current_game === this.n_games) {
                this.current_game = 1;
            }
            this.scroll_to_game(this.current_game);
        },
        num_game(num) {
            switch (num) {
                case 1:
                    return 'melody';
                case 2:
                    return 'dance';
                case 3:
                    return 'rhythm';
                default:
                    return 'sing';
            }
        },
        scroll_to_game(num) {
            let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

            let carousel__viewport = document.getElementById("menu_carousel__viewport");
            switch (num) {
                case 2:
                    if (carousel__viewport.scrollLeft !== width) {
                        carousel__viewport.scrollTo(width, 0);
                    }
                    break;
                case 3:
                    if (carousel__viewport.scrollLeft !== 2*width) {
                        carousel__viewport.scrollTo(2*width, 0);
                    }
                    break;
                case 4:
                    if (carousel__viewport.scrollLeft !== 3*width) {
                        carousel__viewport.scrollTo(3*width, 0);
                    }
                    break;
                default:
                    if (carousel__viewport.scrollLeft !== 0) {
                        carousel__viewport.scrollTo(0, 0);
                    }
                    break;
            }
        },
        somclick(){
            if(this.somTeclas){
           this.click.play();
           }
        }

    },
    created() {
        console.log(this.somTeclas);
    },
    mounted() {
        this.click = new Audio(require('@/assets/sons/click.wav'));
        //click.play();

        let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        let carousel__viewport = document.getElementById("menu_carousel__viewport");
        this.last_scroll = carousel__viewport.scrollLeft;

        carousel__viewport.addEventListener('scroll', () => {
            let scroll = carousel__viewport.scrollLeft;
            let scroll_val = [1, 2, 3, 4];
            if (scroll - this.last_scroll > 0) {
                scroll_val = [0.5, 1.5, 2.5, 4];
            }
            switch (true) {
                case (scroll_val[0] * width <= scroll && scroll < scroll_val[1] * width):
                    this.current_game = 2;
                    break;
                case (scroll_val[1] * width <= scroll && scroll < scroll_val[2] * width):
                    this.current_game = 3;
                    break;
                case (scroll_val[2] * width <= scroll && scroll <= scroll_val[3] * width):
                    this.current_game = 4;
                    break;
                default:
                    this.current_game = 1;
                    break;
            }
            this.last_scroll = scroll;
        })

        /*
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);

        var xDown = null;
        var yDown = null;

        function getTouches(evt) {
            return evt.touches ||
                evt.originalEvent.touches;
        }

        function handleTouchStart(evt) {
            const firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        }

        function handleTouchMove(evt) {
            if (!xDown || !yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            console.log('XD: ' + xDiff);

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff > 0) {
                    // right swipe
                    console.log("swipe r");
                    //this.next_game();

                } else {
                    // left swipe
                    console.log("swipe l");
                    //this.previous_game();
                }
            }
            xDown = null;
            yDown = null;
        }
        */
    }
};
</script>

<style>

.container-menu {
    display: flex;
    width: 100%;
    height: 100%;
}

.icons-menu {
    z-index: 100;
}

.animated-topbutton {
    margin-top: 0;
    animation: movetopbuttons 0.5s ease-in-out;
}

@keyframes movetopbuttons {
    0% {
        margin-top: -1%;
    }

    100% {
        margin-top: 0;
    }
}

.animated-bottombutton {
    margin-bottom: 0;
    animation: movebottombuttons 0.5s ease-in-out;
}

@keyframes movebottombuttons {
    0% {
        margin-bottom: -1%;
    }

    100% {
        margin-bottom: 0;
    }
}

#back {
    position: absolute;
    left: 4%;
    bottom: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

#menu_play {
    position: absolute;
    width: 100%;
    display: flex;
    bottom: 7%;
    justify-content: center;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

#forward {
    position: absolute;
    right: 4%;
    bottom: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

#settings {
    position: fixed;
    right: 4%;
    top: 7%;
    z-index: 10;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

#gallery {
    position: fixed;
    right: 4%;
    top: 25%;
    z-index: 10;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

#profile {
    position: fixed;
    left: 4%;
    top: 7%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    z-index: 10;
}

.fundo {
    width: 100%;
    /*height: 100%;*/
    z-index: -1;
    object-fit: cover;
    position: absolute;
}

.window {
    position: absolute;
    display: flex;
    width: 100%;
    height: 70%;
    top: 7%;
    justify-content: center;
    align-items: center;
    animation: movewindow 4s ease-in-out 2s infinite normal;
}

.tamanhojanelamelodia {
    margin-top: 2%
}

.title-menu {
    color: white;

}

.title {
    font-family: Omnes;
    position: absolute;
    text-align: center;
    width: 100%;
    top: 7%;
    margin-top: 0;
    font-weight: bold;
    font-style: normal;
}

@keyframes movewindow {
    0% {
        transform: rotate(0deg);
    }

    4% {
        transform: rotate(3deg);
    }

    8% {
        transform: rotate(-3deg);
    }

    12% {
        transform: rotate(3deg);
    }

    16% {
        transform: rotate(-3deg);
    }

    20% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(0deg);
    }
}

body {
    margin: 0;
}

.carousel {
    box-sizing: border-box;

    scrollbar-width: 0px;
}

ol,
li {
    list-style: none;
    margin: 0;
    padding: 0;
}

.carousel {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 10px #0003);
    perspective: 100px;
}

.carousel__viewport {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    overflow-x: scroll;
    counter-reset: item;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
}

.carousel__slide {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
}

.carousel__snapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    scroll-snap-align: center;
}

.carousel__navigation {
    position: absolute;
    bottom: 25%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carousel__navigation-list {
    display: flex;
    justify-content: space-around;
    width: 15%;
    height: 12px;
}

.carousel__navigation-button {
    width: 12px;
    border-radius: 100px;
    background-color: rgba(255, 255, 255, 0.5);
    transition: transform 0.1s;
}

.selected-game {
    background-color: rgba(255, 255, 255);
}

.carousel::before,
.carousel::after,
.carousel__prev,
.carousel__next {
    position: fixed;
    bottom: 1rem;
    width: 4rem;
    height: 4rem;
    outline: 0;
}

.carousel::before,
.carousel__prev {
    left: 1rem;
}

.carousel::after,
.carousel__next {
    right: 1rem;
}

.carousel::before,
.carousel::after {
    content: '';
    z-index: 1;
    background-size: 1.5rem 1.5rem;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 2.5rem;
    line-height: 4rem;
    text-align: center;
    pointer-events: none;
}

@media only screen and (max-width: 480px) {
    .tamanhotitle {
        font-size: 0.8rem;
    }

    .tamanhoicon>img {
        width: 2rem;
    }

    .tamanhojanela {
        width: 5rem;
    }

    .tamanhojanelamelodia {
        width: 11rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 3rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 4rem;
    }

    .tamanhojanelasing {
        width: 7rem;
    }

    .carousel__navigation-list {
        height: 7px;
    }

    .carousel__navigation-button {
        width: 7px;
    }

}

@media only screen and (min-width: 480px) and (max-width: 550px) {
    .tamanhotitle {
        font-size: 1rem;
    }

    .tamanhoicon>img {
        width: 2.2rem;
    }

    .tamanhojanelamelodia {
        width: 12rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 4rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 5rem;
    }

    .tamanhojanelasing {
        width: 8rem;
    }

    .carousel__navigation-list {
        height: 8px;
    }

    .carousel__navigation-button {
        width: 8px;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px) {
    .tamanhotitle {
        font-size: 1.2rem;
    }

    .tamanhoicon>img {
        width: 2.4rem;
    }

    .tamanhojanela {
        width: 8rem;
    }

    .tamanhojanelamelodia {
        width: 13rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 5rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 6rem;
    }

    .tamanhojanelasing {
        width: 9rem;
    }

    .carousel__navigation-list {
        height: 9px;
    }

    .carousel__navigation-button {
        width: 9px;
    }
}

@media only screen and (min-width: 630px) and (max-width: 718px) {
    .tamanhotitle {
        font-size: 1.4rem;
    }

    .tamanhoicon>img {
        width: 2.6rem;
    }

    .tamanhojanela {
        width: 9rem;
    }

    .tamanhojanelamelodia {
        width: 15rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 6rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 7rem;
    }

    .tamanhojanelasing {
        width: 10rem;
    }

    .carousel__navigation-list {
        height: 10px;
    }

    .carousel__navigation-button {
        width: 10px;
    }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {
    .tamanhotitle {
        font-size: 1.6rem;
    }

    .tamanhoicon>img {
        width: 2.8rem;
    }

    .tamanhojanela {
        width: 10rem;
    }

    .tamanhojanelamelodia {
        width: 17rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 7rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 8rem;
    }

    .tamanhojanelasing {
        width: 11rem;
    }

    .carousel__navigation-list {
        height: 11px;
    }

    .carousel__navigation-button {
        width: 11px;
    }

}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .tamanhotitle {
        font-size: 1.8rem;
    }

    .tamanhoicon>img {
        width: 3rem;
    }

    .tamanhojanela {
        width: 11rem;
    }

    .tamanhojanelamelodia {
        width: 18rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 8rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 9rem;
    }

    .tamanhojanelasing {
        width: 12rem;
    }

    .carousel__navigation-list {
        height: 12px;
    }

    .carousel__navigation-button {
        width: 12px;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .tamanhotitle {
        font-size: 2.4rem;
    }

    .tamanhoicon>img {
        width: 3.2rem;
    }

    .tamanhojanelamelodia {
        width: 22rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 10rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 11rem;
    }

    .tamanhojanelasing {
        width: 14rem;
    }

    .carousel__navigation-list {
        height: 13px;
    }

    .carousel__navigation-button {
        width: 13px;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .tamanhotitle {
        font-size: 2.6rem;
    }

    .tamanhoicon>img {
        width: 3.4rem;
    }

    .tamanhojanelamelodia {
        width: 26rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 14rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 15rem;
    }

    .tamanhojanelasing {
        width: 18rem;
    }

    .carousel__navigation-list {
        height: 14px;
    }

    .carousel__navigation-button {
        width: 14px;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .tamanhotitle {
        font-size: 2.8rem;
    }

    .tamanhoicon>img {
        width: 4rem;
    }

    .tamanhojanelamelodia {
        width: 30rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 18rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 19rem;
    }

    .tamanhojanelasing {
        width: 22rem;
    }

    .carousel__navigation-list {
        height: 15px;
    }

    .carousel__navigation-button {
        width: 15px;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .tamanhotitle {
        font-size: 3rem;
    }

    .tamanhoicon>img {
        width: 4.4rem;
    }

    .tamanhojanelamelodia {
        width: 34rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 22rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 23rem;
    }

    .tamanhojanelasing {
        width: 26rem;
    }

    .carousel__navigation-list {
        height: 17px;
    }

    .carousel__navigation-button {
        width: 17px;
    }
}

@media only screen and (min-width: 1680px) and (max-width:2350px) {
    .tamanhotitle {
        font-size: 3.2rem;
    }

    .tamanhoicon>img {
        width: 4.8rem;
    }

    .tamanhojanelamelodia {
        width: 38rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 24rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 27rem;
    }

    .tamanhojanelasing {
        width: 30rem;
    }

    .carousel__navigation-list {
        height: 19px;
    }

    .carousel__navigation-button {
        width: 19px;
    }
}

@media only screen and (min-width: 2350px) and (max-width: 2550px) {
    .tamanhotitle{
        font-size: 5rem;
    }

    .tamanhoicon>img {
        width: 6rem;
    }

    .tamanhojanelamelodia {
        width: 46rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 34rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 35rem;
    }

    .tamanhojanelasing {
        width: 38rem;
    }

    .carousel__navigation-list {
        height: 21px;
    }

    .carousel__navigation-button {
        width: 21px;
    }
}
 @media only screen and (min-width: 2550px) {
    .tamanhotitle{
        font-size: 6rem;
    }

    .tamanhoicon>img {
        width: 10rem;
    }

    .tamanhojanelamelodia {
        width: 52rem;
    }

    .tamanhojaneladanca {
        margin-top: 1%;
        width: 40rem;
    }

    .tamanhojanelaritmo {
        margin-top: 1%;
        width: 41rem;
    }

    .tamanhojanelasing {
        width: 44rem;
    }

    .carousel__navigation-list {
        height: 35px;
    }

    .carousel__navigation-button {
        width: 35px;
    }
}
</style>
